import { render, staticRenderFns } from "./NewDialog.vue?vue&type=template&id=b31cf438&scoped=true"
import script from "./NewDialog.vue?vue&type=script&lang=js"
export * from "./NewDialog.vue?vue&type=script&lang=js"
import style0 from "./NewDialog.vue?vue&type=style&index=0&id=b31cf438&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31cf438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b31cf438')) {
      api.createRecord('b31cf438', component.options)
    } else {
      api.reload('b31cf438', component.options)
    }
    module.hot.accept("./NewDialog.vue?vue&type=template&id=b31cf438&scoped=true", function () {
      api.rerender('b31cf438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/oa/notice/NewDialog.vue"
export default component.exports